import { createFileRoute, notFound } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug } from "@/lib/calendar/dates";
import { LiburNasionalPage } from "@/components/pages/LiburNasionalPage";
import { getHolidaysForYear } from "@/data/holidays";
import { itemListSchema, breadcrumbSchema, ldScripts } from "@/lib/seo/schema";
export { HolidayTable, YearLinks } from "@/components/pages/LiburNasionalPage";

export const Route = createFileRoute("/libur-nasional/$year")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (!y) throw notFound();
    return { y };
  },
  head: ({ loaderData }) => {
    const y = loaderData?.y ?? "";
    const events = typeof y === "number"
      ? getHolidaysForYear(y).filter((h) => h.type === "libur").map((h) => ({
          name: h.name, date: h.date, description: `Libur nasional Indonesia ${y}.`,
          url: `/libur-nasional/${y}`,
        }))
      : [];
    return {
      meta: [
        { title: `Libur Nasional ${y} & Tanggal Merah ${y} - Daftar Lengkap SKB 3 Menteri` },
        { name: "description", content: `Daftar lengkap libur nasional dan tanggal merah Indonesia ${y} berdasarkan SKB 3 Menteri. Termasuk libur lebaran, Idul Fitri, Idul Adha, Natal, Imlek, Nyepi, dan tanggal cuti bersama.` },
        { name: "keywords", content: `libur nasional ${y}, tanggal merah ${y}, libur lebaran ${y}, libur ${y}, kalender libur ${y}, cuti bersama ${y}` },
        { property: "og:title", content: `Libur Nasional & Tanggal Merah ${y}` },
        { property: "og:description", content: `Daftar libur nasional dan tanggal merah Indonesia ${y} sesuai SKB 3 Menteri.` },
      ],
      scripts: typeof y === "number" ? ldScripts([
        breadcrumbSchema([
          { name: "Beranda", url: "/" },
          { name: `${y}`, url: `/${y}` },
          { name: `Libur Nasional ${y}`, url: `/libur-nasional/${y}` },
        ]),
        events.length > 0 ? itemListSchema(events, "id") : null,
      ].filter(Boolean) as unknown[]) : [],
    };
  },
  component: LiburPage,
  notFoundComponent: () => (
    <SiteShell>
      <div className="py-16 text-center"><h1 className="text-2xl font-bold">Tahun tidak valid</h1></div>
    </SiteShell>
  ),
});

function LiburPage() {
  const { y } = Route.useLoaderData();
  return <LiburNasionalPage y={y} />;
}